import { db, auth } from './FirebaseConfig';
import { doc, setDoc, getDoc, addDoc, collection, updateDoc, query, where, collectionGroup, getDocs, onSnapshot } from "firebase/firestore";


const createFirestoreSource = () => {

	const max = 10
	let current = 0;

	const incAndCheck = () => {
		current++
		console.groupCollapsed("Checking usage")
		console.trace("Checking usage", current, max)
		console.groupEnd()
		return current >= max
	}

	const subscribeToWebs = async (handleWebs) => {

		console.log("subscribe", auth.currentUser)

		if (current >= max) {
			console.log("hit max: skiping subscribing to webs")
		}

		const websQuery = query(collectionGroup(db, 'Users'), where('email', '==', auth.currentUser.email))
		let unsubscribe
		unsubscribe = onSnapshot(websQuery, querySnapshot => {
			console.log("Webs snapshot", querySnapshot.docs)
			let webs = querySnapshot.docs

			//TODO check if current page is not included

			handleWebs(webs)

			if (incAndCheck()) {
				console.log("hit max: unsubscribing from webs")
				unsubscribe()
			}
		})

		return unsubscribe

	}

	const getSpaces = async (email) => {
		if (incAndCheck()) {
			console.log("hit max: skiping getSpaces")
		}
		return await getDocs(query(collectionGroup(db, 'Users'), where('email', '==', email)));
	}

	const getWeb = async (web) => {
		if (incAndCheck()) {
			console.log("hit max: skiping getWeb")
		}
		return await getDoc(doc(db, "Notes", web))
	}

	const setWeb = async (web, data) => {
		if (incAndCheck()) {
			console.log("hit max: skiping setWeb")
		}
		return await setDoc(doc(db, "Notes", web), data)
	}

	const getPage = async (web, page) => {
		console.log("getPage path", doc(db, "Notes", web, "Pages", page))
		if (incAndCheck()) {
			console.log("hit max: skiping getPage")
		}
		return await getDoc(doc(db, "Notes", web, "Pages", page))
	}

	const addPage = async (web, data) => {
		if (incAndCheck()) {
			console.log("hit max: skiping addPage")
		}
		return await addDoc(collection(db, "Notes", web, "Pages"), data)
	}

	const setPage = async (web, page, data) => {
		if (incAndCheck()) {
			console.log("hit max: skiping setPage")
		}
		console.log("setPage", web, page)
		return await setDoc(doc(db, "Notes", web, "Pages", page), data)
	}

	const updatePage = async (web, page, data) => {
		if (incAndCheck()) {
			console.log("hit max: skiping updatePage")
		}
		return await updateDoc(doc(db, "Notes", web, "Pages", page), data)
	}

	const getUsers = async (web) => {
		if (incAndCheck()) {
			console.log("hit max: skiping getUsers")
		}
		return await getDoc(doc(db, "Notes", web, "Users", "users"))
	}

	const getNewWebId = () => {
		return doc(collection(db, "Notes")).id
	}

	const setPersonUserPage = async (web, email, data) => {
		if (incAndCheck()) {
			console.log("hit max: skiping setPersonUserPage")
		}
		return await setDoc(doc(db, "Notes", web, "Users", email), data)
	}

	const updateUsers = async (web, value) => {
		if (incAndCheck()) {
			console.log("hit max: skiping updateUsers")
		}
		return await updateDoc(doc(db, "Notes", web, "Users", "users"), value)
	}

	return Object.freeze({
		subscribeToWebs,
		getSpaces,
		getWeb,
		setWeb,
		getPage,
		addPage,
		setPage,
		updatePage,
		getUsers,
		getNewWebId,
		setPersonUserPage,
		updateUsers
	})
}

export const firestoreSource = createFirestoreSource()